import ProductGridWindow from '../CategoryPage/ProductGridWindow';
import {
  LoadMoreButton,
  LoadingProductDisplay,
} from '../CategoryPage/WindowedCategoryPage';
import React from 'react';
import { PagePadding } from '../Layout/MaxWidth';
import searchQuery from './SearchQuery.gql';
import qs from 'qs';
import { useLocation } from 'react-router';
import useInfinitePagination from '@jetshop/core/hooks/useInfinitePagination';
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import { SearchHeader } from './SearchHeader';

const WindowedSearchResults = ({ loading, ...props }) => {
  const { total, term, result } = props;
  const { currentPage } = React.useContext(PaginationContext);
  const location = useLocation();
  const params = qs.parse(location.search, { ignoreQueryPrefix: true });

  const { products, previous, next } = useInfinitePagination({
    result,
    query: searchQuery,
  });

  return (
    <div style={{ marginBottom: '3rem' }}>
      <SearchHeader
        total={total}
        term={term}
        loading={loading}
        currentPage={currentPage}
      />
      <PagePadding>
        {previous.hasProducts && (
          <LoadMoreButton
            className="up"
            onClick={(e) => {
              e.preventDefault();
              previous.fetchProducts();
            }}
            to={{
              ...location,
              search: qs.stringify({
                ...params,
                page: previous.page,
              }),
            }}
          />
        )}
        <ProductGridWindow
          id="search"
          prevOffset={previous.offset}
          products={products}
          listName={'search'}
          loading={result.loading}
          imageSizes={[1 / 2, 1 / 2, 1 / 3, 1 / 4]}
        />
        <LoadingProductDisplay amount={products.length} total={total} />
        {next.hasProducts && (
          <LoadMoreButton
            onClick={(e) => {
              e.preventDefault();
              next.fetchProducts();
            }}
            to={{
              ...location,
              search: qs.stringify({
                ...params,
                page: next.page,
              }),
            }}
          />
        )}
      </PagePadding>
    </div>
  );
};

export default WindowedSearchResults;
